module.exports = __webpack_public_path__ + "files/f2dca80f2651a04bbcc8d3587724af45.png";